import React from 'react';

import styles from './EditorTooltip.module.css';

export const EditorTooltipDivider = () => (
  <span className={styles.divider}>|</span>
);

export default EditorTooltipDivider;
